import create from 'zustand';
import { UpdateNonAbapQueryState } from './interfaces/UpdateQueryState';
import { createCommonNonAbapQuerySlice } from './slices/NonAbapQuerySlices/CommonNonAbapQuerySlice';
import { createUpdateNonAbapQuerySlice } from './slices/NonAbapQuerySlices/UpdateNonAbapQuerySlice';

export const useUpdateNonAbapQueryStore = create<UpdateNonAbapQueryState>((set) => ({
  ...createCommonNonAbapQuerySlice(set),
  ...createUpdateNonAbapQuerySlice(set)
}));
